import {
  init,
  Identify,
  identify,
  Types,
  setUserId
} from '@amplitude/analytics-browser';
import { Company } from './react-land/types';

const {
  VUE_APP_AMPLITUDE_API_KEY: amplitudeApiKey,
  VUE_APP_AMPLITUDE_LOG_LEVEL: amplitudeLogLevel,
  VUE_APP_AMPLITUDE_SERVER_ZONE: serverZone
} = process.env;

// 0: none; 1: error; 2: Warn; 3: Verbose; 4: Debug;
const logLevel = (() => {
  const logLevelInt = parseInt(amplitudeLogLevel || '', 10);

  if (isNaN(logLevelInt) || logLevelInt < 0) return 0;

  return Math.min(logLevelInt, 4);
})();

const isValidServerZone = (
  serverZone?: string
): serverZone is Types.ServerZoneType => {
  return serverZone === 'US' || serverZone === 'EU';
};

export function initializeAnalytics() {
  if (amplitudeApiKey) {
    init(amplitudeApiKey, {
      serverZone: isValidServerZone(serverZone) ? serverZone : 'US',
      logLevel,
      remoteConfig: {
        fetchRemoteConfig: true
      }
    });
  }
}

export const identifyUser = (() => {
  let identifiedUserEmail = '';

  return (
    userEmail: string,
    company: Company | null,
    featureFlags: string[] = []
  ) => {
    if (!amplitudeApiKey || identifiedUserEmail === userEmail) {
      return; // prevent recalling identify
    }

    setUserId(userEmail);

    identifiedUserEmail = userEmail;

    const identifyEvent = new Identify();

    if (company) {
      identifyEvent.set('company_name', company.name);
      identifyEvent.set('company_aud', company.aud);
    }

    if (featureFlags.some((feat) => feat === 'Embeddable Integration')) {
      identifyEvent.set('embeddable_integration', true);
    }

    identify(identifyEvent);
  };
})();
